import axios from 'axios'

let prefix = '/ref'

const ReferenceDataApi = {
	getShippingMethods(payload) {
		return axios.get(prefix + '/shipping-methods', { params: payload })
	},

	getCountries(payload) {
		return axios.get(prefix + '/countries', { params: payload })
	},

	getCurrencies(payload) {
		return axios.get(prefix + '/currencies', { params: payload })
	},
	
	getReferenceCustomerList(payload) {
		return axios.get(prefix + '/customers', { params: payload })
	},
}

export default ReferenceDataApi
